// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Tuvalu from '../_raw/flag/icon_flag_tuvalu.png';

export default () => <img src={Tuvalu} alt="Tuvalu" />;
